export enum ErrorsNames {
  USER_SIMILAR_EMAIL= 'USER_SIMILAR_EMAIL',
}
